import { Input, DefaultTooltip, InputGroup, InputGroupText } from "twyne-new.ui";

import { useCraftProp } from "../utils";

export default function FlexStretchProperty() {
  const { value: grow = '', setValue: setGrow } = useCraftProp('flex.grow')
  const { value: shrink = '', setValue: setShrink } = useCraftProp('flex.shrink')

  const formatValue = e => {
    const { value } = e.target
    return value ? Number(value) : ''
  }

  return <>
    <div className='flex items-center justify-between gap-1'>
      <InputGroup>
        <DefaultTooltip contentProps={{ className: 'max-w-32' }} content='How much an item can expand to fill available space.'>
          <InputGroupText>
            Grow
          </InputGroupText>
        </DefaultTooltip>
        <Input
          value={grow}
          onChange={e => setGrow(formatValue(e))}
          type="number"
          variant='accent'
        />
      </InputGroup>

      <InputGroup>
        <DefaultTooltip contentProps={{ className: 'max-w-32' }} content='How much an item can shrink when space is limited.'>
          <InputGroupText>
            Shrink
          </InputGroupText>
        </DefaultTooltip>
        <Input
          value={shrink}
          onChange={e => setShrink(formatValue(e))}
          type="number"
          variant='accent'
        />
      </InputGroup>
    </div>
  </>
}
